import React, { useEffect,useState } from "react";
import { downloadTrigger } from "../../service/StudyListService";
import { Spinner, SpinnerSize } from "@fluentui/react";

const DownloadTrigger = () => {
    const [loading,setLoading] = useState(false);
    const queryString = window.location.search;
    // Create a URLSearchParams object
    const urlParams = new URLSearchParams(queryString);

    // Get a specific query parameter
    const updateOrInsert = urlParams.get('updateOrInsert');
    const tableName = urlParams.get('tableName');
    

    function _base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
      }

    const callDownloadTrigger = async () => {
        setLoading(true);
        try{

        
       const response = await downloadTrigger(tableName,updateOrInsert);
       if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoading(false);
        console.log("---Download Trigger---",response.data.data);
        const downloadFileContentObj = response.data.data;
        if(Object.keys(downloadFileContentObj).length > 0){
            for(const key in response.data.data){
                const fileData = _base64ToArrayBuffer(downloadFileContentObj[key]);
                const file = new Blob([fileData], { type: "application/sql" });
                const url = window.URL.createObjectURL(file);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${key}.sql`); // Append .sql to the file name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); 
            }

               
        }
       }else{
        setLoading(false);
       }
    }catch(e){
        setLoading(false);
        console.log("---Exception---",e);
       }
    }

    useEffect(() => {
        callDownloadTrigger();
    },[])

    const containerStyle = {
        fontFamily: 'Arial, sans-serif',
        padding: '20px',
        backgroundColor: '#1e1e1e',
        border: '1px solid #333',
        borderRadius: '8px',
        color: '#ccc',
        maxWidth: '800px',
        margin: '20px auto',
        overflow: 'auto'
    };
    
    const headingStyle = {
        color: '#f9f9f9',
        marginBottom: '10px',
    };
    
    const codeStyle = {
        backgroundColor: '#2e2e2e',
        padding: '10px',
        border: '1px solid #444',
        borderRadius: '5px',
        fontSize: '12px',
        overflowX: 'auto',
        color: '#dcdcdc',
    };
    
    const listStyle = {
        marginBottom: '10px',
    };
    
    const listItemStyle = {
        marginBottom: '10px',
    };
    
    const codeInlineStyle = {
        color: '#d14',
        backgroundColor: '#2e2e2e',
        padding: '2px 4px',
        borderRadius: '3px',
    };

    const spinnerStyle = {
        circle: {
          height: "50px",
          width: "50px",
          borderWidth: "5px",
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
        }
      }

    return (
    <div className="main-container-body" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '14px' }}>
             {loading && <div
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                zIndex: 1000,
                justifyContent:"center",
                backdropFilter: "blur(1px)",
                alignItems:"center",
                display:"flex"
              }}
            >
              <Spinner size={SpinnerSize.small} styles={spinnerStyle} />
            </div>}
             
            <div style={containerStyle}>
                <h2 style={headingStyle}>Download SQL Trigger Files</h2>
                <p>You can use the following API endpoint to download SQL trigger files based on your needs:</p>
                <pre style={codeStyle}>
                    <code>
                    {`${window.location.origin}/download/trigger?updateOrInsert=`}<span style={codeInlineStyle}>insert</span>&tableName=
                    </code>
                </pre>

                <h3 style={headingStyle}>Parameters:</h3>
                <ul style={listStyle}>
                    <li style={listItemStyle}><strong>updateOrInsert</strong>: Specifies the type of trigger to download. Acceptable values are <code style={codeInlineStyle}>insert</code> or <code style={codeInlineStyle}>update</code>.</li>
                    <li style={listItemStyle}><strong>tableName</strong> (optional): Specifies the table for which you want the trigger.
                        <ul>
                            <li style={listItemStyle}>If <code style={codeInlineStyle}>tableName</code> is provided (e.g., <code style={codeInlineStyle}>tableName=user</code>), the file will include the trigger for that specific table.</li>
                            <li style={listItemStyle}>If <code style={codeInlineStyle}>tableName</code> is omitted, the file will include triggers for all tables.</li>
                        </ul>
                    </li>
                </ul>

                <h3 style={headingStyle}>Example Usages:</h3>
                <ul style={listStyle}>
                    <li style={listItemStyle}>To download the <code style={codeInlineStyle}>INSERT</code> trigger for all tables:
                        <pre style={codeStyle}>
                            <code>
                            {`${window.location.origin}/download/trigger?updateOrInsert=`}<span style={codeInlineStyle}>insert</span>
                            </code>
                        </pre>
                    </li>
                    <li style={listItemStyle}>To download the <code style={codeInlineStyle}>INSERT</code> trigger for the <code style={codeInlineStyle}>user</code> table:
                        <pre style={codeStyle}>
                            <code>
                            {`${window.location.origin}/download/trigger?updateOrInsert=`}<span style={codeInlineStyle}>insert</span>&tableName=user
                            </code>
                        </pre>
                    </li>
                    <li style={listItemStyle}>To download the <code style={codeInlineStyle}>UPDATE</code> trigger for all tables:
                        <pre style={codeStyle}>
                            <code>
                            {`${window.location.origin}/download/trigger?updateOrInsert=`}<span style={codeInlineStyle}>update</span>
                            </code>
                        </pre>
                    </li>
                    <li style={listItemStyle}>To download the <code style={codeInlineStyle}>UPDATE</code> trigger for the <code style={codeInlineStyle}>user</code> table:
                        <pre style={codeStyle}>
                            <code>
                            {`${window.location.origin}/download/trigger?updateOrInsert=`}<span style={codeInlineStyle}>update</span>&tableName=user
                            </code>
                        </pre>
                    </li>
                </ul>

                <p>By using these API requests, you can easily manage and retrieve SQL triggers as needed.</p>
            </div>
        </div>
    )
}

export default DownloadTrigger;